import Vue from 'vue'
import axios from 'axios'

axios.defaults.baseURL = 'https://teste-3cad5.firebaseio.com/'

Vue.use({
    install(Vue){
        Vue.prototype.$http = axios
    }
})